export default __webpack_public_path__ + "static/media/bar_chart_arrow_red.e37b38b8.svg";